import { isDefined } from '@aloft/toolkit-shared';

import { useTkv2NullableOrderContext } from '../../../controller/hooks/useTkv2NullableControllerOrder.ts';
import { usePropertyCoordinates } from '../../../hooks/usePropertyCoordinates.ts';
import { selectPropertyIdentificationById } from '../../../redux/features/selectors/propertyDataSelectors/propertyIdentificationSelectors.ts';
import { selectToolkitListingID } from '../../../redux/features/selectors/propertyDataSelectors/transactionSelectors.ts';
import { useAppSelector } from '../../../redux/hooks.ts';

export const useSubjectPinCoordinates = () => {
  const ctx = useTkv2NullableOrderContext();
  const subject = ctx !== null ? ctx.subject : undefined;

  const propertyIdentification = useAppSelector((state) =>
    selectPropertyIdentificationById(state, 'subject'),
  );
  const craftsmanListingID = useAppSelector((state) => selectToolkitListingID(state, 'subject'));

  const address = isDefined(subject)
    ? subject?.body.getStructuredData('address')
    : propertyIdentification?.address;
  const listingID = isDefined(subject)
    ? subject?.body.getStructuredData('toolkitListingID')
    : craftsmanListingID;

  const alreadyHaveCoords = isDefined(propertyIdentification?.coordinates);
  const coordsWithGeoCodeFallback = usePropertyCoordinates({
    address,
    listingID,
    alreadyHaveCoords,
  });

  return alreadyHaveCoords
    ? {
        isLoading: false,
        coordinates: {
          lat: propertyIdentification?.coordinates?.latitude,
          lng: propertyIdentification?.coordinates?.longitude,
        },
      }
    : coordsWithGeoCodeFallback;
};
